import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const MenuSectionModelSchema = z
  .object({
    id: z.string(),
    key: z.string(),
    name: z.string(),
    icon: z.string(),
    default: z.boolean(),
    sequence: z.number()
  })
  .strict()

const MenuSectionModelFields = makeFieldKeys(MenuSectionModelSchema)

type MenuSectionModel = z.infer<typeof MenuSectionModelSchema>
